import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';

import { DbQuestion } from '~src/types/db';
import { QueryKeys } from './queryKeys';
import { getSharedTenderMyQuestionsList } from '~src/services/api/questions';
import { ResponseWithPagination } from '~src/types/api';

export const useSharedTenderMyQuestions = (
  params: Parameters<typeof getSharedTenderMyQuestionsList>[0],
  queryConfig: QueryConfig<ResponseWithPagination<DbQuestion>, AxiosError> = {}
) => {
  const { enabled, ...options } = queryConfig;

  const enabledOverride = enabled || enabled === undefined;

  const filesQuery = useQuery(
    [QueryKeys.sharedTenderMyQuestion, params],
    () => getSharedTenderMyQuestionsList(params),
    {
      enabled: enabledOverride,
      ...options,
    }
  );

  return filesQuery;
};
